import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHandcycleNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17.5 15c.458 0 .887-.123 1.256-.338l2.952 1.694-2.001 2.144h-4.075c-.532 0-1.02-.298-1.262-.772l-3.917-7.66-2.226 1.138 3.714 7.263c-.71-.035-1.358-.1-1.949-.185a5 5 0 10-.779 2.41c1.132.185 2.447.306 3.954.306H15.5v-.002l.132.002h4.618c.346 0 .677-.144.914-.397l1.056-1.132A5.002 5.002 0 0032 18a5 5 0 00-8.547-3.524L20 12.494A2.5 2.5 0 1017.5 15zm-15 3a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM27 15.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHandcycleNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHandcycleNormalMedium;
